import {
  GET_GOALS,
  ADD_OR_EDIT_GOAL,
  DELETE_GOAL,
  GOALS_LOADING,
  CLEAR_GOALS
} from '../types';
import { IAction, IGoal } from '../../types/interfaces';

const initialState = {
  goals: [],
  loading: false
};

interface IState {
  goals: IGoal[];
}

export default function(state: IState = initialState, action: IAction) {
  switch (action.type) {
    case GET_GOALS:
      return {
        ...state,
        goals: action.payload,
        loading: false
      };
    case GOALS_LOADING:
      return {
        ...state,
        loading: true
      };
    case CLEAR_GOALS:
      return {
        ...state,
        goals: []
      };
    // case DELETE_GOAL:
    //   return {
    //     ...state,
    //     goals: state.goals.filter(goal => goal.lineIndex !== action.payload)
    //   };
    case ADD_OR_EDIT_GOAL:
      const returnArray: IGoal[] = action.payload;
      let resArray = [...state.goals];
      for(let i in returnArray){
        if(resArray.find(e => e.id === returnArray[i].id))
          resArray = resArray.map(e => e.id === returnArray[i].id ? returnArray[i] : e)
        else
          resArray.push(returnArray[i])
      }
      return {
        ...state,
        goals: resArray
        // goals: state.goals.find(e => e.id == action.payload.id) ? state.goals.map(e => e.id == action.payload.id ? action.payload : e) : [...state.goals, action.payload]
      };
    default:
      return state;
  }
}
